/* eslint-disable */
import React from "react";
import { getSrcSet, getSizes, buildCmsUrl } from "../../utils/imageHelper";


import back_asset from "../../assets/01_Home/Icon_Left.svg";
import read_more_icon from "../../assets/hyundai-icono-ver-mas.svg";
import { Link } from "react-router-dom";

interface DestacadosComponentProps {
  categories: any;
}

const DestacadosComponent: React.FC<DestacadosComponentProps> = ({
  categories,
}) => {
  // Ordenar por fecha de creación (de más reciente a más antiguo)
  const sortedCategories = categories
    ? [...categories].sort(
        (a: any, b: any) =>
          new Date(b.creation_datetime).getTime() -
          new Date(a.creation_datetime).getTime()
      )
    : [];

  return (
    <>
      <div className="destacados-normal-news">
        <div className="title">Destacados</div>
        <div className="categories row">
          {sortedCategories.map((item: any) => (
            <div
              key={item?.id}
              className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4"
            >
              <Link to={`/noticias/${item?.category_id}/${item?.slug}`} className="category">
                <img 
                  src={buildCmsUrl(item?.media?.url)} 
                  srcSet={getSrcSet(item?.media?.url || '')}
                  sizes={getSizes('300px')}
                  alt={item?.title || "Imagen destacada"} 
                />

                <div className="subtitle">{item?.category}</div>
                <div className="description">{item?.title}</div>
                <div className="readMore">Leer más</div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default DestacadosComponent;